// import {CustomSelect} from './select/custom-select';
import {Form} from './form-validate/form';
import {uploadImageDrop} from './input-file/init-upload';

const init = () => {
	uploadImageDrop();
	// const select = new CustomSelect();
	// select.init();
	const form = new Form();
	window.form = form;
	form.init();
};

export default {
	init,
};
